import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Text } from '@soteria/design-system-ve';

import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

import { NonTriggeredPolicyRow } from './NonTriggeredPolicyRow';

interface PolicyAssessment {
  policyId: string;
  policyName: string;
  isCorrect: boolean | null;
  comments?: string;
}

interface NonTriggeredPoliciesSectionProps {
  selectedItem: GraphQLAuditItem;
  nonTriggeredPolicyAssessments: PolicyAssessment[];
  isSessionCompleted: boolean;
  onNonTriggeredPolicyAssessmentChange: (assessment: PolicyAssessment) => void;
}

export function NonTriggeredPoliciesSection({
  selectedItem,
  nonTriggeredPolicyAssessments,
  isSessionCompleted,
  onNonTriggeredPolicyAssessmentChange,
}: NonTriggeredPoliciesSectionProps) {
  const nonTriggeredPolicies = selectedItem?.contentSnapshot?.nonTriggeredPolicies || [];

  if (nonTriggeredPolicies.length === 0) {
    return null;
  }

  return (
    <div className={spacingStyles.flexColumn}>
      <Text className={styles.subsectionTitle}>Nontriggered Policies ({nonTriggeredPolicies.length})</Text>
      <div className={spacingStyles.assessmentGroup}>
        {nonTriggeredPolicies.map(policy => {
          const assessment = nonTriggeredPolicyAssessments.find(a => a.policyId === policy.id);

          return (
            <NonTriggeredPolicyRow
              key={policy.id}
              assessment={assessment}
              disabled={isSessionCompleted}
              policy={policy}
              onAssessmentChange={onNonTriggeredPolicyAssessmentChange}
            />
          );
        })}
      </div>
    </div>
  );
}
